<template>
  <div>
    <div class="footerpc">
      <img src="/images/footerp.png" />
      <div class="footerpc__text">Nuestros socios:</div>
    </div>
    <div class="footermovil">
      <div class="footermovil__text">Nuestros socios:</div>
      <img src="/images/footerp.png" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.footerpc {
  width: 100%;
  height: 127px;
  background-color: #f9fbfc;
  margin-top: 680px;
  display: inline-block;
  justify-content: center;
  justify-items: center;
  text-align: center;
  vertical-align: middle;
  line-height: normal;
  align-content: center;
  @media screen and (max-width: 768px) {
    display: none;
  }

  &__text {
    font-family: 'Avenir-Medium';
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    height: 53px;
    font-style: normal;
    letter-spacing: -0.16px;
    text-align: center;
    color: #000;
    line-height: 53px;
    margin: 0 auto;
    margin-right: 24px;
    @media screen and (max-width: 768px) {
      width: 100%;
      background: blue;
      text-align: center;
      margin-right: 0px;
      display: none;
    }
  }
  img {
    width: 445px;
    height: 53px;
    margin-top: 20px;
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
}
.footermovil {
  width: 100%;
  display: none;
  height: 100px;
  background-color: #f9fbfc;
  margin-top: 680px;

  justify-content: center;
  justify-items: center;
  text-align: center;
  vertical-align: middle;
  line-height: normal;
  align-content: center;
  @media screen and (max-width: 768px) {
    display: inline-flex;
    background-color: #f9fbfc;
    background-image: url('/images/nuestros_socios.png');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 40%;
    margin-top: 820px;
  }
  @media screen and (max-width: 680px) {
    background-size: 45%;
  }
  @media screen and (max-width: 600px) {
    background-size: 50%;
  }
  @media screen and (max-width: 540px) {
    background-size: 55%;
  }
  @media screen and (max-width: 480px) {
    background-size: 60%;
    margin-top: 750px;
  }
  @media screen and (max-width: 400px) {
    background-size: 70%;
  }
  @media screen and (max-width: 360px) {
    background-size: 75%;
  }
  &__text {
    font-family: 'Avenir-Medium';
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    height: 53px;
    font-style: normal;
    letter-spacing: -0.16px;
    text-align: left;
    color: #000;
    line-height: 53px;
    margin-right: 24px;
    @media screen and (max-width: 768px) {
      width: 100%;
      background: blue;
      text-align: center;
      margin-right: 0px;
      display: none;
      margin-top: 20px;
    }
  }
  img {
    width: 445px;
    height: 53px;
    margin-left: 24px;
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
}
</style>
